module.exports = "<div id=\"content\" class=\"buffets\">\n\t<h2>buffets</h2>\n\t<ul>\n\t\t<li><a routerLink=\"/buffets/jeanne\">buffet Jeanne</a></li>\n\t\t<li><a routerLink=\"/buffets/justine\">buffet Justine</a></li>\n\t\t<li><a routerLink=\"/buffets/lina\">buffet Lina</a></li>\n\t\t<li><a routerLink=\"/buffets/marie\">buffet Marie</a></li>\n\t</ul>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buffets/buffets.component.html
// module id = 585
// module chunks = 1